<template>
  <div class="side-panel-contenter">
    <private-border />
    <div class="box">
      <div class="box-title clearfix">
          <slot name="box-title"></slot>
      </div>
      <div class="box-inner">
        <slot name="box-inner"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import PrivateBorder from './border'
export default {
  components: { PrivateBorder }
}
</script>

<style lang="less" scoped>
.side-panel-contenter {
  position: relative;
  height: 100%;
  .box {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100px;
    height: 100%;
    padding: 10px 12px 16px;
    z-index: 2;
    .box-title {
      height: 26px;
      padding: 6px 100px 0 16px;
      .title {
        float: left;
        position: relative;
        font-size: 16px;
        color: #00a8ff;
        font-weight: bold;
        letter-spacing: 1px;
        padding-left: 25px;
        &::after {
          position: absolute;
          content: '';
          top: 7px;
          left: 6px;
          width: 6px;
          height: 6px;
          border: 2px solid #00a8ff;
          transform: rotate(45deg);
        }
      }
    }
    .box-inner {
      flex: 1;
      min-height: 0;
    }
  }
}
</style>